export function handlerTitleTime(time) {
    if (time) {
        const day = time.substring(8, 10);
        return day
    }
}

export function handlerYears(time) {
    if (time) {
        const years = time.substring(0, 7);
        return years
    }
}


// WEBPACK FOOTER //
// ./src/utils/handlerTime.js